import { useState, useEffect, useContext } from "react";
import { Activity_log_func } from "../../../api/activity_log/activity_log_func";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Input, Tooltip } from "@fluentui/react-components";
import { BookTemplate20Regular, Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Dismiss16Regular, CheckboxCheckedSync20Regular, PulseSquare20Regular, ShieldLock20Regular, SquareHintApps20Regular, BoxCheckmark20Regular, AppsListDetail20Filled, AppsList20Regular, Info16Filled } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { GlobalContext } from "../../../hooks/globalContext";
import { ToastComponent } from "../../../components/toast/toast.component";
import { primaryIcon, lightTheme, overflowDivider, secondaryIcon, buttonContent, DynamicBoxingCSS, heightResponsive, parentHome, wraperStyle, SubSectionResponsive, dashboardTheme, BreadcrumbsBorder, timezoneInfo } from "../../../styles/customStyles";
import { FileDownloadComponent } from "../../../components/fileExport/file.export.component";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import { convertToExcelFormat, convertToLocalTimezone, convertUTCToReadableFormat } from "../../../utility/utils";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import { AutomateAppPages } from "../../../components/side_menu/InlineSidenav";

export const Activitylog_Automate = () => {
    const navigate = useNavigate();
    const contextValue: any = useContext(GlobalContext);
    const handle = useFullScreenHandle();
    const { permissions } = usePermissionStore();
    const tenantName = contextValue.tenantName;
    var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / '); const [final_data, set_final_data]: any = useState(null);
    const [tableData, setTableData] = useState([]);
    const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
    const [overlayOpen, setOverlayOpen] = useState(false);
    const [searchVal, setSearchVal] = useState("");
    const [totalPages, setTotalPages] = useState(1);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [exportData, setExportData] = useState([]);
    const [exportDetails, setExportDetails]: any = useState([]);
    const [isRefresh, setRefresh] = useState(false);
    const [refreshToast, setRefreshToast]: any = useState(false);
    const [isToast, setIsToast] = useState(false);
    const [isfilter, setIsFilter] = useState(false);
    const [activity, setActivity]: any = useState('{}');
    const [isResetDisabled, setResetDisabled] = useState(true);
    const [filterMenuOpen, setFilterMenuOpen] = useState(false);
    const [filterArray, setFilterArray] = useState<string[]>([]);
    const [dropDownValue1, setDropDownValue1] = useState<any>();
    const [dropDownValue2, setDropDownValue2] = useState<any>();
    const [overlayData, setOverlayData] = useState<any>(false);
    const [activityExportData, setActivityExportData] = useState<any>('No data available');
    const [exportBtnClicked, setExportBtnClicked] = useState(false);
    const [loading, setLoading] = useState(true);
    const [uniqueCreatedBy, setUniqueCreatedBy] = useState<string[]>([]);
    const [uniqueModule, setUniqueModule] = useState<string[]>([]);
    const [uniqueAction, setUniqueAction] = useState<string[]>([]);
    const [uniqueStatus, setUniqueStatus] = useState<string[]>([]);

    // Options for each filter category
    const [createdByOptions, setCreatedByOptions] = useState<any[]>([]);
    const [moduleOptions, setModuleOptions] = useState<any[]>([]);
    const [actionOptions, setActionOptions] = useState<any[]>([]);
    const [statusOptions, setStatusOptions] = useState<any[]>([]);

    useEffect(() => {
        setCreatedByOptions(uniqueCreatedBy?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
        setModuleOptions(uniqueModule?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
        setActionOptions(uniqueAction?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
        setStatusOptions(uniqueStatus?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
    }, [uniqueCreatedBy, uniqueModule, uniqueAction, uniqueStatus]);

    const handleFilterArray = (): void => {
        const value1 = dropDownValue1;
        const value2 = dropDownValue2;
        // Check if the column is already filtered
        const columnExists = filterArray.some(filter => filter.startsWith(`${value1} :`));
        if (!columnExists) {
            const result = `${value1} : ${value2}`;
            setFilterArray([...filterArray, result]);
            setIsFilter(true);
            setLoading(true);
            setDropDownValue1('');
            setDropDownValue2('');
        }
    };
    const handleCloseFilter = (index: any): any => {
        console.log("clicked");
        const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
        setFilterArray(updatedArray);
        setDropDownValue1('');
        setDropDownValue2('');
    }
    useEffect(() => {
        if (filterArray.length > 0)
            setResetDisabled(false)
    }, [filterArray])

    const inputChange = (e: any) => {
        const enteredValue = e.target.value;
        console.log("entered value", enteredValue)
        let name = e.target.name;
        const regexS = /^[A-Za-z ]*$/;
        const regexSN = /^[A-Za-z0-9 ]*$/;
        const regexN = /^[0-9]*$/;
        if (name === 'filter' && dropDownValue1 === ("Activity")) {
            if (regexSN.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
        if (name === 'filter' && dropDownValue1 === ("Action") || dropDownValue1 === ("Initiated by") || dropDownValue1 === ("Module")) {
            if (regexS.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
    }

    //data table column name code starts here
    var columns = [
        { key: "date", label: <Body1Strong> &nbsp;&nbsp;Date (UTC) </Body1Strong> },
        { key: "date_timezoned",
            label: <>
            <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                <StackItem>
                <Body1Strong>&nbsp;&nbsp;Date</Body1Strong>
                </StackItem>
                <StackItem align="center">
                <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                    <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                </Tooltip>
                </StackItem>
            </Stack>
            </>
        },
        { key: "page", label: <Body1Strong> Module </Body1Strong> },
        { key: "activity", label: <Body1Strong> Activity </Body1Strong> },
        { key: "initiated_by", label: <Body1Strong> Initiated by </Body1Strong> },
        { key: "action", label: <Body1Strong> Action </Body1Strong> },
        { key: "status", label: <Body1Strong> Status </Body1Strong> },
    ];
    //data table column name code ends here

    //data table for filter column
    var columns1 = [
        { key: "date", label: <Caption1> Date </Caption1> },
        { key: "module", label: <Caption1> Module </Caption1> },
        { key: "activity", label: <Caption1> Activity </Caption1> },
        { key: "initiated_by", label: <Caption1> Initiated by </Caption1> },
        { key: "action", label: <Caption1> Action </Caption1> },
        { key: "status", label: <Caption1> Status </Caption1> },
    ];
    // overflow set contents code starts here
    var overFlowComponent = {
        data:
            <>
                <StackItem>
                    <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => {
                        setCurrentPageNo(1); setRefresh(true); setLoading(true);
                    }}>
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
                            <StackItem> <Caption1> Refresh </Caption1> </StackItem>
                        </Stack>
                    </Button>
                </StackItem>

                <StackItem>
                    {
                        permissions.includes("all") || permissions.includes("appLog_ReadandExport") ? (
                            <>
                                <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_swd_activitylog.csv`}>
                                </CSVLink>
                                <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true); }}>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem>{loading ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                                        <StackItem> <Caption1> Export </Caption1> </StackItem>
                                    </Stack>
                                </Button>
                            </>
                        ) :
                            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                                <Button shape="circular" appearance="subtle" size="small" disabled>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem>
                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                                                <StackItem><Caption1> Export </Caption1></StackItem>
                                            </Stack>
                                        </StackItem>
                                    </Stack>
                                </Button>
                            </Tooltip>
                    }
                </StackItem>
            </>
        ,
    };
    // overflow set contents code ends here
    var tempTableData: any = [];

    useEffect(() => {
        var tempExportData: any = [];

        exportDetails?.length > 0 && exportDetails.map((val: any) => {
            tempExportData.push({
                'Date': val.time ? convertToExcelFormat(val.time) : "-",
                'Module': val.pageName,
                'Activity': JSON.parse(val?.activity)?.summary,
                'Initiated By': val.initiatedBy,
                'Action': val.action,
                'Status': val.status,
            });
        });

        setExportData(tempExportData);
    }, [exportDetails]);

    useEffect(() => {
        exportData.length > 0 && document.getElementById('csv-export-link')?.click();
    }, [exportData]);

    useEffect(() => {
        if (final_data !== undefined && final_data !== null) {
            const newUniqueCreatedBy: string[] = [];
            const newUniqueModule: string[] = [];
            const newUniqueAction: string[] = [];
            const newUniqueStatus: string[] = [];

            final_data.forEach((val: any) => {
                if (val.initiatedBy && val.initiatedBy.trim() !== "-" && !newUniqueCreatedBy.includes(val.initiatedBy)) {
                    newUniqueCreatedBy.push(val.initiatedBy);
                }
                if (val.pageName && val.pageName.trim() !== "-" && !newUniqueModule.includes(val.pageName)) {
                    newUniqueModule.push(val.pageName);
                }
                if (val.action && val.action.trim() !== "-" && !newUniqueAction.includes(val.action)) {
                    newUniqueAction.push(val.action);
                }
                if (val.status && val.status.trim() !== "-" && !newUniqueStatus.includes(val.status)) {
                    newUniqueStatus.push(val.status);
                }
            });
            // Set the unique values for each filter category
            setUniqueCreatedBy(newUniqueCreatedBy);
            setUniqueModule(newUniqueModule);
            setUniqueAction(newUniqueAction);
            setUniqueStatus(newUniqueStatus);
        } else {
            setUniqueCreatedBy([]);
            setUniqueModule([]);
            setUniqueAction([]);
            setUniqueStatus([]);
        }
    }, [final_data]);

    useEffect(() => {
        // data table values append code starts here
        console.log("final_data=", final_data);
        final_data !== undefined && final_data !== null
            ? final_data.map((val: any, i: any) => {
                var activityVal = JSON.parse(val?.activity)?.summary;
                if (val.pageName !== 'Devices' && (val.pageName === "App Installation" || val.pageName === "App monitor" || val.pageName === "Activity Log" || val.pageName === "App uninstall")) {
                    {
                        permissions.includes("all") || permissions.includes("appLog_ReadandExport") ?
                            tempTableData.push({
                                id: val.ID,
                                checkbox: "hide",
                                date: { label: <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={() => { setOverlayOpen(true); setOverlayData(val); setActivity(JSON.parse(val.activity)); }}> {val.time ? convertUTCToReadableFormat(val.time) : ''} </Button>, id: `${i}` },
                                date_timezoned: { label: <Caption1>  {val.time ? convertToLocalTimezone(val.time, userTimeZone) : ''} </Caption1>, id: `${i}` },
                                page: { label: <Caption1> {val.pageName} </Caption1>, status: "" },
                                activity: { label: <Caption1> {activityVal} </Caption1> },
                                initiated_by: { label: <Caption1> {val.initiatedBy} </Caption1> },
                                action: { label: <Caption1> {val.action} </Caption1> },
                                status: { label: <Caption1> {val.status} </Caption1> },
                            })
                            :
                            tempTableData.push({
                                id: val.ID,
                                checkbox: "hide",
                                date: { label: <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above"><Button shape="circular" style={buttonContent} appearance="transparent" size="small"> {val.time ? convertUTCToReadableFormat(val.time) : "-"} </Button></Tooltip>, icon: "", id: `${i}` },
                                date_timezoned: { label: <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small"> {val.time ? convertToLocalTimezone(val.time, userTimeZone) : "-"} </Button>, icon: "", id: `${i}` },
                                page: { label: <Caption1> {val.pageName} </Caption1>, status: "" },
                                activity: { label: <Caption1> {activityVal} </Caption1> },
                                initiated_by: { label: <Caption1> {val.initiatedBy} </Caption1> },
                                action: { label: <Caption1> {val.action} </Caption1> },
                                status: { label: <Caption1> {val.status} </Caption1> },
                            })
                    }
                }
            }) : (tempTableData = []);

        tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
        setTimeout(() => {
            final_data !== undefined && final_data !== null && setLoading(false);
        }, 500);
    }, [final_data, permissions, filterMenuOpen]);
    // data table ,values append code ends here

    useEffect(() => {
        var data = '';

        data = `Activity
    \nDate and time of activity - ${overlayData?.time ? new Date(overlayData?.time * 1000).toLocaleString() : ''}
    \nModule where the activity was performed - ${overlayData?.pageName}
    \nActivity - ${activity?.summary}
    \nInitiated by - ${overlayData?.initiatedBy}
    \nAction - ${overlayData?.action}
    \nStatus - ${overlayData?.status}`;

        if (overlayData?.pageName === "App Install status") {
            if (overlayData?.action === 'Export') {
                data += `\n----------------------------------------
        \nTarget
        \nNot applicalble`;

                data += `\n----------------------------------------
        \nModified properties
        \nNot applicalble`;
            }
        } else if (overlayData?.pageName === "App Uninstall status") {
            if (overlayData?.action === 'Export') {
                data += `\n----------------------------------------
            \nTarget
            \nNot applicalble`;

                data += `\n----------------------------------------
            \nModified properties
            \nNot applicalble`;
            }
        } else if (overlayData?.pageName === "Status") {
            if (overlayData?.action === 'Export') {
                data += `\n----------------------------------------
            \nTarget
            \nNot applicalble`;

                data += `\n----------------------------------------
            \nModified properties
            \nNot applicalble`;
            }
        } else if (overlayData?.pageName === "Discovered Apps") {
            if (overlayData?.action === 'Export') {
                data += `\n----------------------------------------
            \nTarget
            \nNot applicalble`;

                data += `\n----------------------------------------
            \nModified properties
            \nNot applicalble`;
            }
        }

        setActivityExportData(data);
    }, [overlayData]);
    //overlay code starts here
    var overLayData: any = {
        headerTitle:
            (
                <>
                    <Stack>
                        <Text size={600} weight="semibold"> Audit Log Details </Text>
                    </Stack>
                </>
            ),
        size: "large",
        isTabs: true,
        tabItems: {
            Activity:
                <FluentProvider theme={dashboardTheme}>
                    <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
                        <StackItem>
                            <Body1Strong> Date and time of activity (UTC) </Body1Strong> - <Caption1> {overlayData?.time ? new Date(overlayData?.time * 1000).toLocaleString() : ''} </Caption1>
                        </StackItem>

                        <StackItem>
                            <Body1Strong> Date and time of activity ({userTimeZone})</Body1Strong> - <Caption1> {overlayData?.time ? convertToLocalTimezone(overlayData?.time, userTimeZone) : ''} </Caption1>
                        </StackItem>

                        <StackItem>
                            <Body1Strong> Module where the activity was performed  </Body1Strong> - <Caption1>{overlayData?.pageName}</Caption1>
                        </StackItem>

                        <StackItem>
                            <Body1Strong> Activity </Body1Strong> - <Caption1>{activity?.summary}</Caption1>
                        </StackItem>

                        <StackItem>
                            <Body1Strong> Initiated By </Body1Strong> - <Caption1>{overlayData?.initiatedBy}</Caption1>
                        </StackItem>

                        <StackItem>
                            <Body1Strong> Action </Body1Strong> - <Caption1>{overlayData?.action}</Caption1>
                        </StackItem>

                        <StackItem>
                            <Body1Strong> Status </Body1Strong> - <Caption1>{overlayData?.status}</Caption1>
                        </StackItem>

                    </Stack>
                </FluentProvider>
        },
        footerData:
            (
                <>
                    <FileDownloadComponent data={activityExportData} fileName="Activity_log" />
                </>
            )
    }
    //overlay code ends here

    return (
        <>
            <FullScreen handle={handle} className="fullScreenBackgroundColor">
                <StackItem grow shrink style={BreadcrumbsBorder}>
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem grow shrink>
                            <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                                <StackItem><Text></Text></StackItem>
                                <StackItem grow shrink>
                                    <Breadcrumbs
                                        items={[
											{ name: "Automate", link: "/home" },
                                            {name:"Apps", link:"/automate/apps/appmonitored"},
                                            {name:"Activity Log", link:"#"}
                                        ]} 
                                    /> 
                                </StackItem>
                            </Stack>
                        </StackItem>
                        <StackItem grow shrink>
                            <Stack horizontalAlign="end">
                                <StackItem grow shrink>
                                    <FullScreenButton handle={handle} />
                                </StackItem>
                            </Stack>
                        </StackItem>
                    </Stack>
                </StackItem>
                <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
                    <StackItem style={DynamicBoxingCSS}>
                        {/* pages code starts here */}
                        <Stack style={DynamicBoxingCSS}>
                            <FluentProvider style={parentHome} theme={dashboardTheme}>
                                <Stack style={parentHome} horizontal >
                                    {/* SPACING BETWEEN INLINE AND PAGE */}
                                    <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={AutomateAppPages("Activity Log")} />
                                    <StackItem style={DynamicBoxingCSS}>
                                        <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                                            <StackItem>
                                                <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                                                <Divider />
                                            </StackItem>
                                            <StackItem style={wraperStyle}>
                                                <StackItem>
                                                    <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                                                        <Stack horizontal tokens={{ childrenGap: 10 }}>
                                                            <StackItem>
                                                                <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Module"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                                                            </StackItem>
                                                            <StackItem>
                                                                <MenuDropdown open={filterMenuOpen} btn=
                                                                    {
                                                                        <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                                {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                                                                <Body1> Filter </Body1>
                                                                            </Stack>
                                                                        </MenuButton>
                                                                    } itemVal={
                                                                        <>
                                                                            <Body1Strong> Add a Filter </Body1Strong>
                                                                            <Divider />
                                                                            <MenuList>
                                                                                <Stack tokens={{ childrenGap: 5 }}>
                                                                                    <StackItem> <Text></Text> </StackItem>
                                                                                    <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                                                                    <DropdownComponent optionData={columns1} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                                                                    <StackItem> <Divider /> </StackItem>
                                                                                    <StackItem> <Caption1> Value </Caption1> </StackItem>
                                                                                    {(dropDownValue1 === 'Date') && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />}
                                                                                    {dropDownValue1 === "Activity" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />))}
                                                                                    {dropDownValue1 === "Initiated by" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={createdByOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                                                                    {dropDownValue1 === "Module" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={moduleOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                                                                    {dropDownValue1 === "Action" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={actionOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                                                                    {dropDownValue1 === "Status" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={statusOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                                                                    <StackItem> <Divider /> </StackItem>
                                                                                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                                                        <StackItem> <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false) }}
                                                                                            disabled={!dropDownValue1?.trim() || !dropDownValue2?.trim() || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                                                                            <Caption1> Apply </Caption1> </Button> </StackItem>
                                                                                        <StackItem> <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(" "); setDropDownValue2(" ") }}> <Caption1> Cancel </Caption1> </Button> </StackItem>
                                                                                    </Stack>
                                                                                </Stack>
                                                                            </MenuList>
                                                                        </>
                                                                    }
                                                                />
                                                            </StackItem>
                                                            <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                                                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                        <StackItem> <FilterDismiss20Filled /> </StackItem>
                                                                        <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                                                    </Stack>
                                                                </Button>
                                                            </StackItem>
                                                        </Stack>
                                                        {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                                                    </Stack>
                                                    <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                                                        <StackItem>
                                                            {filterArray.length > 0 &&
                                                                // <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                                                                <Stack wrap horizontal >
                                                                    {filterArray.length > 0 && filterArray.map((item, index) => (
                                                                        <Button shape="circular" size="small">
                                                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                                <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                                                                <StackItem>
                                                                                    <Stack tokens={{ childrenGap: 1 }}>
                                                                                        <StackItem><Text></Text></StackItem>
                                                                                        <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                                                                    </Stack>
                                                                                </StackItem>
                                                                            </Stack>
                                                                        </Button>
                                                                    ))}
                                                                    {/* </Stack> */}
                                                                </Stack>}
                                                        </StackItem>

                                                        <StackItem disableShrink>
                                                            {(tableData.length > 0 && !loading) && (
                                                                totalRecords > 0 &&
                                                                <Caption1>
                                                                    Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                                                </Caption1>
                                                            )}
                                                        </StackItem>
                                                    </Stack>
                                                </StackItem>
                                                <InfoBar showSpaces={true} title={"Logs for activities performed in the Devices module."} />
                                            </StackItem>
                                            <Activity_log_func data={final_data} func={set_final_data} searchVal={searchVal} pageNo={(currentPageNo - 1) * 50} setTotalPages={setTotalPages} setTotalRecords={setTotalRecords} isFilter={isfilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2} type="getLog" moduleName="appsAutomate" setExportDetails={setExportDetails} setRefresh={setRefresh} isRefresh={isRefresh} setRefreshToast={setRefreshToast} setExportBtnClicked={setExportBtnClicked} exportBtnClicked={exportBtnClicked} filterArray={filterArray} filterMenuOpen={filterMenuOpen} />
                                            {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={columns} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}> No results were found for the selected tenant. </Text></StackItem></Stack>}
                                            {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </FluentProvider>
                        </Stack>
                        <OverLay
                            overlayopen={overlayOpen}
                            setOverlayOpen={setOverlayOpen}
                            overlayData={overLayData} />
                    </StackItem>
                    <StackItem><Text></Text></StackItem>
                </Stack>
            </FullScreen>
        </>
    );
};